import React, { useState } from 'react';

interface CollapsibleSectionProps {
  title: string;
  defaultExpanded?: boolean;
  children: React.ReactNode;
  count?: number;
}

export function CollapsibleSection({
  title,
  defaultExpanded = true,
  children,
  count,
}: CollapsibleSectionProps) {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  return (
    <div className="bg-neutral-50 dark:bg-slate-800/50 rounded-lg border border-neutral-200 dark:border-slate-700 overflow-hidden">
      <button
        type="button"
        onClick={() => setIsExpanded(!isExpanded)}
        className="
          w-full flex items-center justify-between
          px-5 py-3.5
          text-left
          hover:bg-neutral-100 dark:hover:bg-slate-700/50
          transition-colors duration-150
          cursor-pointer
        "
      >
        <div className="flex items-center gap-2">
          <h5 className="text-base font-semibold text-neutral-900 dark:text-white">
            {title}
          </h5>
          {count !== undefined && (
            <span className="
              px-1.5 py-0.5 text-xs font-medium rounded-full
              bg-neutral-200 dark:bg-slate-600
              text-neutral-600 dark:text-slate-300
            ">
              {count}
            </span>
          )}
        </div>
        <svg
          className={`
            w-4 h-4 text-neutral-400 dark:text-slate-500
            transition-transform duration-200
            ${isExpanded ? 'rotate-0' : '-rotate-90'}
          `}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
        </svg>
      </button>
      {isExpanded && (
        <div className="px-5 pb-4 animate-fade-in">
          {children}
        </div>
      )}
    </div>
  );
}
